import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import Swal from 'sweetalert2';
import axios from "axios";
import QuestionContents from './UI/QuestionContents';
import { useAuth } from '../../../../../context/AuthContext';
import { useParams } from "react-router-dom";
import './matchcss.css';

const TrueFalse = (props) => {
    const { t } = useTranslation();
    const [msg, setMsg] = useState([]);
    const [question, setQuestion] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [questionTitle, setQuestionTitle] = useState([]);
    const [questionText, setQuestionText] = useState([]);
    const [attempt, setAttempt] = useState(0);
    const { user } = useAuth();
    const params = useParams();
    const [subjectName, setSubjectName] = useState("");
    const ATTEMPT_KEY = `choice_attempt_${props.questionNumber}`;

    const getSubject = async () => {
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            };
            let url = "https://api.heryerdeingilizce.com/api/user/Content/GetSubject";
            await axios({
                method: 'GET',
                url: url,
                headers: headerss,
                params: {
                    courseId: params['courseid'],
                }
            }).then(res => {
                if (res.data['success']) {
                    setSubjectName(res.data['data']['subjects'][params['subjectid'] - 1]['subjectName'] + " - " + res.data['data']['subjects'][params['subjectid'] - 1]['subjectDesc'])
                }
            });
        } catch (err) {
            console.log();
        }
    };
    const Request = async (userAnswer) => {
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            };
            let url = "https://api.heryerdeingilizce.com/api/user/Content/Answer";
            await axios({
                method: 'POST',
                url: url,
                params: {
                    courseId: Number(params.courseid),
                    question: Number(props.data.id),
                    answer: userAnswer.toString()
                },
                headers: headerss
            }).then(res => {
                localStorage.removeItem(ATTEMPT_KEY);
                console.log("Answer Response:", res.data);
                if (res.data['success']) {
                    props.playSuccessSound?.();
                    Swal.fire({
                        title: "Başarılı!",
                        icon: "success",
                        confirmButtonText: `Tamam`,
                        timer: 3000,
                    }).then(() => {
                        let newurl = Number(params['id']) + 1;
                        window.location.href = "/user/course/question/" + params['courseid'] + "/" + params['subjectid'] + "/" + newurl;
                    });
                }
                else {
                    if (res.data['alertType'] === "question") {
                        props.playErrorSound?.();
                        Swal.fire({
                            title: "Hatalı cevap",
                            //text: "Doğru Cevap: " + res.data['message'],
                            text: props.data.notfyText,
                            icon: "error",
                            confirmButtonText: `Tamam`,
                        }).then(() => {
                            let newurl = Number(params['id']) + 1;
                            window.location.href = "/user/course/question/" + params['courseid'] + "/" + params['subjectid'] + "/" + newurl;
                        });
                    }
                    else {
                        let errorMsg = res['data']['message'];
                        props.playErrorSound?.();
                        Swal.fire({
                            title: "Hata",
                            text: errorMsg,
                            icon: "error",
                            confirmButtonText: `Tamam`,
                        }).then(() => {
                            let newurl = Number(params['id']) + 1;
                            window.location.href = "/user/course/question/" + params['courseid'] + "/" + params['subjectid'] + "/" + newurl;
                        });
                    }
                }
            });
        } catch (err) {
            setMsg(err.message);
        }
    };

    const answerTrueFalseHandle = async (e) => {
        e.preventDefault();
        let userAnswer = "";
        for (let i = 0; i < props.truefalseanswercount; i++) {
            const trueEl = document.getElementById(i + ".true");
            const falseEl = document.getElementById(i + ".false");
            if (trueEl.checked) {
                userAnswer += "true";
            } else if (falseEl.checked) {
                userAnswer += "false";
            } else {
                Swal.fire({
                    icon: 'warning',
                    title: 'Lütfen tüm seçenekleri cevaplayın.',
                    confirmButtonText: 'Tamam'
                });
                return;
            }
            if (i < props.truefalseanswercount - 1) userAnswer += ",";
        }
        const attempt = parseInt(localStorage.getItem(ATTEMPT_KEY) || "0", 10);
        const correctAnswer = props.data.answer;

        //1. DENEME
        if (attempt === 0 || attempt === 1) {
            if (userAnswer === correctAnswer) {
                Request(userAnswer);
            } else {
                localStorage.setItem(ATTEMPT_KEY, String(attempt + 1));

                props.playErrorSound?.();

                Swal.fire({
                    title: attempt === 0 ? "Tekrar Deneyiniz!" : "Son bir kez deneyiniz!",
                    text: props.data.notfyText,
                    icon: "warning",
                }).then(() => window.location.reload());
            }
            return;
        }

        // 2. DENEME → DİREKT BACKEND
        Request(userAnswer);


    };
    useEffect(() => {
        if (localStorage.getItem(ATTEMPT_KEY) === null) {
            localStorage.setItem(ATTEMPT_KEY, "0");
        }
    }, [ATTEMPT_KEY]);
    useEffect(() => {

        getSubject();
        setQuestion(JSON.parse(props.data.contentStr));
        setAnswers(JSON.parse(props.data.detail));
        let que = JSON.parse(props.data.contentStr);
        let questionTitlee = que['text'].split('__')[0];
        let questionTextt = que['text'].split('__')[1];
        setQuestionTitle(questionTitlee);
        setQuestionText(questionTextt);
    }, []);

    return (
        <div>
            <span style={{ color: "black" }}> <b><i>{subjectName}</i></b></span>
            <br />
            <b>True False Sorusu</b>
            <br />
            <div style={{ textAlign: "center" }}>
                <QuestionContents question={question} />
                {!(question?.type === "sound" || question?.type === "video" || question?.type === "image" || question?.type === "image_sound") && (
                    <>
                        <br />
                        <br />
                    </>
                )}
                <b style={{ fontSize: "18px", fontFamily: 'calibri', color: "SteelBlue" }}>
                    {questionTitle}
                </b>

            </div>
            <div style={{ textAlign: "left" }}>
                <br /> <br />
                <b style={{ fontSize: "24px", fontFamily: 'calibri', color: "black" }}>
                    {questionText}
                </b>
                <hr />
            </div>
            <form onSubmit={answerTrueFalseHandle} className="tf-form">
                <div className="tf-list">
                    {answers && answers.map((dt) => (
                        <div key={dt.id} className="tf-item">

                            <div className="tf-text">
                                <b>{dt['service']}</b>
                            </div>

                            <div className="tf-options">
                                <label className="tf-option">
                                    <input
                                        type="radio"
                                        name={"inlineRadioOptions" + dt.id}
                                        id={dt.id + ".true"}
                                    />
                                    <span>True</span>
                                </label>

                                <label className="tf-option">
                                    <input
                                        type="radio"
                                        name={"inlineRadioOptions" + dt.id}
                                        id={dt.id + ".false"}
                                    />
                                    <span>False</span>
                                </label>
                            </div>

                        </div>
                    ))}
                </div>

                <br /><br />

                {props.answered ? (
                    <div className="tf-answered">
                        <b>cevaplanmış <i>{props.realanswer}</i></b>
                    </div>
                ) : (
                    <div className="tf-submit">
                        <button type="submit" className="save-btn">
                            {t("saveAndContinue")}
                        </button>
                    </div>
                )}
            </form>
            <hr />
        </div>
    );
};

export default TrueFalse;
